// How the app shortens a person's name: the first name to greet them by and the initials for an
// avatar. One rule for the sidebar, the Today greeting and the Team card. Pure TypeScript so it
// can be unit-tested under Vitest's node environment.

// A leading "Md"/"Mohammad"-style prefix is not what people are called: "Md Sohel Rana" is
// Sohel, initials SR (not MS). The same in Bangla: "মোঃ" (with the visarga), also typed "মো:" or
// "মো.", so "মোঃ আমিনুল ইসলাম" is আমিনুল, initials আই.
const NAME_PREFIX = /^(?:(?:md|mohd|mohammad|mohammed|muhammad)\.?|মো[ঃ:.])$/i

function nameParts(name: string | null | undefined): string[] {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean)
  // NFC: "মো" typed as ে + া is the same word as the one-character vowel sign ো.
  return words.length > 1 && NAME_PREFIX.test((words[0] ?? '').normalize('NFC')) ? words.slice(1) : words
}

/** The name to greet someone by. */
export function firstNameOf(name: string | null | undefined): string {
  return nameParts(name)[0] ?? ''
}

/** First and last initials for an avatar; "?" when there is no name. */
export function initialsOf(name: string | null | undefined): string {
  const parts = nameParts(name)
  const first = parts[0]?.[0] ?? ''
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : ''
  return (first + last).toUpperCase() || '?'
}
